var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.035 34.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.87 18.99s.016.029.168.279c.233.382.584.922.872 1.21 1.032 1.032 2.41 1.6 3.878 1.6s2.847-.568 3.88-1.6l5.102-5.103a5.492 5.492 0 0 0 0-7.757 5.491 5.491 0 0 0-7.758 0L18.041 9.59l-.255.256-.747.746c-.137.138-.093.277.098.31l1.434.245a.769.769 0 0 0 .597-.19l2.091-2.091a3.727 3.727 0 0 1 5.263 0 3.726 3.726 0 0 1 0 5.263l-5.102 5.102c-.7.7-1.634 1.085-2.632 1.085a3.695 3.695 0 0 1-2.63-1.085c-.282-.28-.588-.864-.757-1.24l-.168-.375c-.034-.091-.12-.11-.188-.04L13.91 18.71a.248.248 0 0 0-.039.279"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.27 15.16-.168-.278c-.233-.382-.584-.923-.872-1.21-1.032-1.033-2.41-1.601-3.878-1.601s-2.847.568-3.879 1.601l-5.102 5.102a5.492 5.492 0 0 0 0 7.758 5.491 5.491 0 0 0 7.757 0L16.1 24.56l.256-.256.746-.746c.138-.137.093-.277-.098-.31l-1.433-.245a.767.767 0 0 0-.598.19l-.461.462-1.63 1.63a3.727 3.727 0 0 1-5.263 0 3.726 3.726 0 0 1 0-5.264l5.103-5.102a3.688 3.688 0 0 1 2.63-1.084c.999 0 1.933.385 2.632 1.084.28.281.588.864.756 1.24l.168.376c.035.09.12.108.188.04l1.136-1.136a.248.248 0 0 0 .039-.279"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.ec1e7dd44115afaabef6b1b4f0824465.svg";
export { ForwardRef as ReactComponent };